import { Avatar, Message } from '@chatscope/chat-ui-kit-react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => {
  return {}
})
const MessageContent = ({ message }) => {
  const classes = useStyles()

  return (
    <Message model={message} >
      <Message.Header sentTime={message.sentTime} sender={message.sender} />
      {(message?.direction === 'incoming') && <Avatar src={message.avatar} name={message.sender} />}


    </Message>)
}

export { MessageContent };
